@if (form; as form) {
  <form [formGroup]='form' (ngSubmit)='submit()' autocomplete='off' novalidate>
    <fieldset>
      <legend>
        Etapy
      </legend>
      <app-tab-view
        [simple]='false'
        (onAddNew)='form.addStage()'
        addBtnTitle='Dodaj kolejny etap'
        [showAddButton]='true'
        [centered]='true'
        formArrayName="stages">
        @for (stageForm of form.getStageForms(); track $index) {
          <app-tab-panel
            (onClose)='form.removeStage($index)'
            [closeBtnDisabled]='$index === 0'
            [showCloseBtn]='true'
            [name]='"Etap nr " + ($index + 1)'
            [selected]='$index === (form.stages.controls.length - 1)'>
            <app-ad-placement-stage-form
              [form]="stageForm"
              [label]='"Etap nr " + ($index + 1)'>
            </app-ad-placement-stage-form>
          </app-tab-panel>
        }
      </app-tab-view>
    </fieldset>
    <br>
    <div class='form-actions'>
      @if (showCancel) {
        <button type='button' class='btn btn-secondary' (click)='cancel()'>
          <i class='fa fa-ban'></i>Anuluj
        </button>
      }
      <button type='submit' class='btn btn-secondary' *ngIf='edit'>
        <i class='fa fa-save'></i>Zaktualizuj dane
      </button>
      <button type='submit' class='btn btn-secondary' *ngIf='!edit'>
        <i class='fa fa-plus'></i>Dołącz do wniosku
      </button>
    </div>
  </form>
}
